// extracted by mini-css-extract-plugin
module.exports = {"answer":"Answer_answer__1kfYq","answerPrefix":"Answer_answerPrefix__1ZCu8","selected":"Answer_selected__3Eywg"};